import { configureStore } from "@reduxjs/toolkit"
import chatReducer from "./slices/chatSlice"
import projectsReducer from "./slices/projectsSlice"
import workflowsReducer from "./slices/workflowsSlice"

export default configureStore({
    reducer: {
        chat: chatReducer,
        projects: projectsReducer,
        workflows: workflowsReducer,
    },
})
